import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Form} from 'antd';
import {layout, Button} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import companyInfoActions from 'Actions/enterpriseConfig/enterpriseConfig';
import TableList from './tableList';
import ConfigModal from './modal/configModal';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;

class CompanyInfo extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false, // 列表loading
      isShowConfigModal: false, // 配置弹框是否可见
    };
  }

  // 设置配置弹框显示隐藏
  setConfigModalVisible = () => {
    const {isShowConfigModal} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isShowConfigModal: !isShowConfigModal,
      },
      () => {
        const {isShowConfigModal: currentIsShowConfigModal} = this.state;

        if (!currentIsShowConfigModal) {
          actions.setConfigModalData({});
        }
      },
    );
  };

  render() {
    const {tableListLoading, isShowConfigModal} = this.state;

    return (
      <React.Fragment>
        <BaseContentMainHeader title="企业信息配置">
          <Form layout="inline">
            <FormItem>
              <Button type="success" onClick={this.setConfigModalVisible}>
                <span>添加企业</span>
              </Button>
            </FormItem>
          </Form>
        </BaseContentMainHeader>

        <TableList
          loading={tableListLoading}
          getTableList={this.getTableList}
          setConfigModalVisible={this.setConfigModalVisible}
        />

        {isShowConfigModal ? (
          <ConfigModal
            getTableList={this.getTableList}
            setConfigModalVisible={this.setConfigModalVisible}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  companyInfo: state.companyInfo,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(companyInfoActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CompanyInfo);
